import React from "react";
import PageHero from "../components/ui-custom/PageHero";
import SectionHeading from "../components/ui-custom/SectionHeading";
import GlassCard from "../components/ui-custom/GlassCard";
import StatCounter from "../components/ui-custom/StatCounter";
import Reveal from "../components/ui-custom/Reveal";
import { companyInfo, heroStats } from "../data/mock";

const AboutUs = () => {
  return (
    <div>
      <PageHero
        eyebrow="Corporate / About Us"
        title="Quality Power"
        subtitle={companyInfo.description}
      />

      <section className="px-6 pb-20">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <GlassCard className="p-8 md:p-12 grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
              {heroStats.map((s, i) => (
                <StatCounter key={s.label} value={s.value} suffix={s.suffix} label={s.label} glow={i % 2 === 0 ? "cyan" : "amber"} />
              ))}
            </GlassCard>
          </Reveal>

          <div className="space-y-6">
            {companyInfo.aboutLong.map((para, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="text-base md:text-lg text-muted-foreground leading-relaxed">{para}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-5xl mx-auto">
          <SectionHeading align="left" eyebrow="Our Vision" title={companyInfo.visionTitle} subtitle={companyInfo.vision} />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
